<template>
  <page :loading="loading" class="mt-4">
    <template #content>
      <SubTopBar>
        <v-btn text class="mr-3">
          <a
            :href="'data:text/plain;charset=utf-8,' + yaml"
            download="user_data.yaml"
          >
            <v-icon class="mr-1">mdi-download</v-icon>
            <span>Export data as yaml</span>
          </a>
        </v-btn>
        <v-btn text @click="dialog = true">
          <v-icon class="mr-1">mdi-delete</v-icon>
          <span>Delete account</span>
        </v-btn>
      </SubTopBar>
      <v-col cols="6" class="ml-3">
        <h2>Export your personal data</h2>
        <p>You can export all your personal data as a single yaml file</p>
        <ul>
          <li><v-icon class="icon icon-success" dense> mdi-check-circle-outline </v-icon> Email addresses</li>
          <li><v-icon class="icon icon-success" dense> mdi-check-circle-outline </v-icon> Phone numbers</li>
          <li><v-icon class="icon icon-success" dense> mdi-check-circle-outline </v-icon> API keys</li>
          <li><v-icon class="icon icon-success" dense> mdi-check-circle-outline </v-icon> SSH keys</li>
          <li><v-icon class="icon icon-success" dense> mdi-check-circle-outline </v-icon> Organizations membership</li>
        </ul>
        <h2>Deleting your account</h2>
        <p>Before deleting your account</p>
        <ul>
         <li><v-icon class="icon icon-success" dense> mdi-check-circle-outline </v-icon> Export all your personal data</li>
         <li><v-icon class="icon icon-success" dense> mdi-check-circle-outline </v-icon> Transfer ownership of your organizations </li>
        </ul>
        <p>What happens when you delete your IAM account?</p>
        <ul>
         <li><v-icon class="icon icon-wran" dense>mdi-alert</v-icon> Deleted IAM accounts cannot be restored</li>
         <li><v-icon class="icon icon-wran" dense>mdi-alert</v-icon> You will loose all access given through IAM</li>
         <li><v-icon class="icon icon-wran" dense>mdi-alert</v-icon> All your access tokens will become invalid</li>
         <li><v-icon class="icon icon-wran" dense>mdi-alert</v-icon> All organizations where your user is the only owner will become unmanageable</li>
         <li><v-icon class="icon icon-wran" dense>mdi-alert</v-icon> All your personal data will be permanently removed from IAM</li>
        </ul>
      </v-col>
      <v-dialog
        transition="dialog-bottom-transition"
        max-width="600"
        v-model="dialog"
      >
        <template v-slot:default="dialog">
          <v-card>
            <v-toolbar
              color="primary"
              dark
            >Deleting your account</v-toolbar>
            <v-card-text class="card-body">
              <p class="mt-5">Enter Your user name: </p>
              <v-text-field
                outlined
                dense
                v-model="verifyUsername"
                label="User Name"
                placeholder="Enter your user name"/>
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn
                text
                @click="dialog.value = false"
              >Close</v-btn>
              <v-btn
                color="primary"
                text
                @click="validateUsername"
              >Confirm</v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
      <v-dialog
        transition="dialog-bottom-transition"
        max-width="600"
        v-model="confirmDialog"
      >
        <template>
          <v-card>
            <v-toolbar
              color="primary"
              dark
            >Deleting your account</v-toolbar>
            <v-card-text class="card-body">
              <div class="dialog-body">
                <div class="body-icon mr-3"><v-icon class="icon icon-wran" dense>mdi-alert</v-icon></div>
                <div class="body-content">
                  <p class="mt-5">You cannot restore a deleted account, your data will be lost forever.</p>
                  <template v-if="lastOwnerOrgs.length">
                    <p>These organizations will become unmanageable if you delete your account:</p>
                    <span  
                      class="mr-2 mt-2 organization-chip"
                      v-for="org in lastOwnerOrgs"
                      :key="org"
                    >
                      {{ org }}
                    </span>
                  </template>
                </div>
              </div>
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn
                text
                @click="confirmDialog = false"
              >Close</v-btn>
              <v-btn
                color="primary"
                text
                @click="deleteUser"
              >Confirm</v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
    </template>
  </page>
</template>

<script>
const YAML = require("json-to-pretty-yaml")

export default {
  data() {
    return {
      loading: true,
      yaml: "",
      deleting: false,
      verifyUsername: '',
      dialog: false,
      confirmDialog: false,
      lastOwnerOrgs: []
    }
  },
  created: function () {
    this.load()
  },
  methods: {
    load() {
      this.$api.getUserInformationYaml(
        this.username,
        this.callBack(
          (response) => {
            const data = YAML.stringify(response)
            this.yaml = encodeURI(data)
          },
          err => {this.alert("error", err.message)}
        )
      )
      this.$api.getUserOrganizations(this.username, this.callBack(
        response => {
          this.lastOwnerOrgs = []
          response.owner.forEach(org_name => {
            this.$api.getOrganization(org_name, this.callBack(
              org_members => {
                if (org_members.owners.length === 1) {
                  this.lastOwnerOrgs.push(org_name)
                }
              }))
          })
        }, undefined, ()=> {
          this.loading = false
        }
      ))
    },
    deleteUser() {
      this.deleting = true
      this.$api.deleteCurrentUser(
        this.username,
        this.callBack(
          () => {
            this.$router.push({ name: "Login"})
          },
          err => {this.alert("error", err.message)},
          () => {
            this.deleting = false
          }
        )
      )
    },
    validateUsername() {
      this.dialog = false
      if (this.verifyUsername === this.username) {
        this.confirmDialog = true
      }else{
        this.alert("error", "Wrong user name")
      }
    }
  },
}
</script>

<style scoped>
a {
  text-decoration: unset;
  color: inherit;
}
h2{
  font-weight:400;
}
p{
  margin-bottom: 7px;
  margin-left: 7px;
  font-size: 15px;
  font-family: Roboto,Arial,sans-serif;
  font-weight: 400;
  letter-spacing: 0.01785714em;
  line-height: 1.25rem;
  hyphens: auto;
  color: rgb(95,99,104);
  margin-top: 12px;
}
ul{
  margin-bottom: 20px;
}
ul>li{
  font-size: 14px;
  color: grey;
  list-style-type: none;
}
.icon{
  font-size: 14px;
  margin-left:-7px;
  margin-right:5px;
}
.icon-wran{
  color:#fb8c00;
}
.icon-success{
  color:#4caf50;
}
.card-body{
  padding-bottom:0 !important;
}
.organization-chip{
  background-color: transparent;
  border-radius: 16px;
  font-size: 14px;
  height: 32px;
  border-width: thin;
  border-style: solid;
  border-color: rgba(0, 0, 0, 0.12);
  color: rgba(0, 0, 0, 0.87);
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  overflow: hidden;
  padding: 0 12px;
  position: relative;
}
.dialog-body{
  display: flex;
  align-items: center;
}
.body-icon > .icon{
  font-size: 77px;
}
</style>